<app-rich-text-templates [isEnoteTemplate]="true" (enoteTemplateClick)="openEnoteRichTextTemplate($event)"></app-rich-text-templates>



